var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0004 12.7127C30.0004 11.8955 29.3379 11.2329 28.5206 11.2329H20.0453C19.228 11.2329 18.5654 11.8955 18.5654 12.7127V17.1522C18.5654 17.9695 19.228 18.632 20.0453 18.632H28.5206C29.3379 18.632 30.0004 17.9695 30.0004 17.1522V12.7127ZM22.8051 16.6769C21.8524 16.6769 21.08 15.9046 21.08 14.9518C21.08 13.9991 21.8524 13.2268 22.8051 13.2268C23.7579 13.2268 24.5302 13.9991 24.5302 14.9518C24.5302 15.9044 23.7579 16.6769 22.8051 16.6769Z",
    fill: "#FF6700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6156 9.21521H27.5785V4.77575C27.5785 3.66306 26.7182 2.75781 25.6053 2.75781H2.06274C0.950045 2.75781 0 3.66306 0 4.77575V25.2242C0 26.3369 0.950045 27.2421 2.06274 27.2421H25.6053C26.718 27.2421 27.5785 26.3369 27.5785 25.2242V20.6502H16.6356L16.6156 9.21521Z",
    fill: "#FF6700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.762eaddb32776de13125087f96655872.svg";
export { ForwardRef as ReactComponent };